module.exports = __webpack_public_path__ + "img/fz_s.7685cf0c.svg";